import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../auth.service';;
import { environment } from 'src/environments/environment';


@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate() {
    if (this.authService.isTokenExpired()) {
      location.href = "/"
    } else {
      return true
    }
  }

  canActivateChild() {
    if (this.authService.isTokenExpired()) {
      location.href = "/"
    } else {
      return true
    }

  }

}
